
import { Product } from "@/types/product";

export const hdbasetTransmitters: Product[] = [
  {
    id: "dxe-cat-tx1-4k",
    groupId: "hdbaset",
    name: "DXE-CAT-TX1-4K",
    description: "About\n\nThe DXE-CAT-TX1-4K is the transmitter of the growing Digital XTreme Series. The DXE-CAT-TX1-4K transmitter has improved features and functionality while maintaining a competitive advantage. The DXE-CAT transmitter is unique as it not only has all connectors on one side for easier and cleaner integration, but also offers additional features not found on other units in this class. In addition to HDMI transmission, bi-directional IR and RS-232 functionality is included for complete control options. This device was made to be paired with the DXE-CAT receiver to create a complete solution.\n\nThe transmitter includes connectors for 1x HDMI, 1x HDBaseT (RJ-45), bidirectional 3.5mm TRS IR, bidirectional 3.5mm TRS RS-232, and a power connector. The HDBaseT port is connected to the HDBaseT port of the receiver unit and works over a single CAT cable (5e/6/6a/7) at distances up to 230ft (70m) for 4K, and 330ft (100m) for 1080p 60Hz. All audio and video features are automatically supported as they pass through the extender.\n\nPower can be supplied to the unit from the included wall supply. The DXE-CAT-TX1-4K offers unique features such as Power over Ethernet (PoE). This eliminates the need for external power sources and allows the DXE-CAT receivers to be powered directly from the transmitter.\n\nAll DXE-CAT products conform to the HDBaseT Alliance guidelines and are fully compatible with other HDBaseT-compliant devices.",
    features: [
      "Transmit HDMI up to 4K 30Hz 4:4:4 (230ft) over one CAT6 cable",
      "4K UHD Resolution",
      "All connectors on one side for easier installation",
      "Bi-directional RS-232 & IR",
      "PoE eliminates dual power supplies",
      "Status LED for all connections on front",
      "Support for multiple mounting options"
    ],
    specifications: [
      "Video Distance (CAT5e/6/6a/7): 230ft (70m) 4K/330ft (100m) 1080p",
      "Video Bandwidth: 10.2Gbps",
      "Video Support: 4K 30Hz RGB/4:4:4 8-bit",
      "HDCP Compliance: Yes",
      "Audio Support: All HDMI Embedded Audio, Including Dolby TrueHD, Dolby Digital Plus and DTS-HD Master Audio transmission",
      "IR without LXC: 30k-60kHz",
      "IR Output with LXC: 30Hz-100kHz",
      "IR Input with LXC: 30k-60kHz",
      "RS-232: Bi-Directional 115k Baud Rate",
      "Front LED Status: Power, Status, HDMI, HDBaseT, RS-232 TX/RX, IR In/Out",
      "Front Selections: Reset",
      "HDBaseT Connector: RJ-45 WE/SS 8P8C",
      "RS-232 Connector: 3.5mm TRS",
      "IR Connector: 3.5mm TRS (Auto Sensing Direction for Blaster or Receiver)",
      "HDMI Connector: Type A 19 pin",
      "Power Connector: 2.1/5.5mm DC Single",
      "Mechanical: Mounting Size 1RU ½ Rack Width",
      "Dimensions [L x W x H]: 120mm x 77mm x 27.94mm [4.72\" x 3.03\" x 1.1\"]",
      "Weight: 395g [14 oz]",
      "Power Supply: 24v DC (External - Not Included)",
      "Power Consumption: 5 Watts [max]",
      "Operation Temperature: 0~40°C [32~104°F]",
      "Storage Temperature: -20~60°C [-4~140°F]",
      "Relative Humidity: 20~90% RH [No Condensation]"
    ],
    images: [
      "/lovable-uploads/c64fdfce-4f16-4de9-99ac-eab1591b2a0f.png",
      "/lovable-uploads/84d10298-d342-4ce3-aa2e-d65722d9d727.png"
    ],
    image: "/lovable-uploads/c64fdfce-4f16-4de9-99ac-eab1591b2a0f.png",
    slug: "dxe-cat-tx1-4k"
  },
  {
    id: "dxe-cat-tx2-4k",
    groupId: "hdbaset",
    name: "DXE-CAT-TX2-4K",
    description: "About\n\nThe DXE-CAT-TX2-4K is part of Aurora's growing Digital Xtreme CAT Series. The DXE-CAT-TX2-4K HDBaseT™ transmitter has improved features and functionality while maintaining a competitive advantage. The DXE-CAT-TX2-4K is unique as it not only has all connectors on one side for easier and cleaner integration, but also offers additional features not found on units at this price point. In addition to HDMI transmission, bi-directional IR, RS-232 control functionality, and dual 100BaseT LAN ports are included for complete options. The DXE-CAT TX2-4K has ultra-low latency for crisp video quality without motion artifacts.\n\nPower can be supplied to the unit from the included wall supply (Not included with some models) and offers advanced features such as Power over HDBaseT™ (PoH). This eliminates the need for external power sources at either the transmitter or receiver locations as they pass power between each other depending on which unit has power connected. The DXE-CAT-TX2-4K can be paired with the DXE-CAT-RX2-4K, DXE-CAT-RX5-4K, or DXE-CAT-RX6-4K for specified system requirements.\n\nIndustry standard HDBaseT™ technology and low power, this unit has a compact enclosure for attachment to projectors, or under tables, and can also be rack-mounted with optional accessory. Every DXE-CAT TX2-4K is built to the exceptional standards customers have come to expect from Aurora.",
    features: [
      "Transmit HDMI up to 4K 30Hz 4:4:4 (230ft) over one CAT cable",
      "HDMI 1.4, 3D & 4K UHD Resolution Support",
      "All Connectors on one side for cleaner installation",
      "Dual 100Mbps LAN Ports",
      "Bi-directional RS-232 & IR",
      "PoH (Transmit power to Receiver)",
      "Status LEDs for all connections"
    ],
    specifications: [
      "Video Distance (CAT 5e/6/6a/7): 230ft (70m) 4K/330ft (100m) 1080p",
      "Video Bandwidth: 10.2Gbps",
      "Video Support: 4K 30Hz RGB/YCC 4:4:4 8-bit",
      "HDCP Compliance: Yes",
      "Audio Support: All HDMI Embedded Audio, Including Dolby TrueHD, Dolby Digital Plus and DTS-HD Master Audio transmission",
      "IR without LXC: 30k-60kHz",
      "IR Output with LXC: 30-100kHz",
      "IR Input with LXC: 30k-60kHz",
      "RS-232: Bi-Directional 115k Baud Rate",
      "LAN: 2x 100BaseT",
      "Front LED Status: Power, Status, HDMI, HDBaseT, IR In/Out, RS-232 TX/RX",
      "Front Selections: Reset, Setup",
      "HDBaseT Connector: RJ-45 WE/SS 8P8C",
      "RS-232 Connector: 3.5mm TRS",
      "IR Connector: 3.5mm TRS (Auto Sensing Direction for Blaster or Receiver)",
      "HDMI Connector: Type A 19 pin",
      "LAN Connector: RJ-45",
      "Power Connector: 2.1/5.5mm DC Jack, Locking",
      "Mechanical: Mounting Size 1RU ½ Rack Width",
      "Dimensions [L x W x H]: 120mm x 77mm x 27.94mm [4.72\" x 3.03\" x 1.1\"]",
      "Weight: 395g [14 oz]",
      "Power Supply: 24v DC 15 Watt (Not Included with some models)",
      "Power Consumption: 7 Watts [max]",
      "Operation Temperature: 0~40°C [32~104°F]",
      "Storage Temperature: -20~60°C [-4~140°F]",
      "Relative Humidity: 20~90% RH [No Condensation]"
    ],
    images: [
      "/lovable-uploads/7c77e150-f844-4d85-87e2-9e7cbb1d2f35.png",
      "/lovable-uploads/0acd57ed-f66d-485e-877d-e573b8289b9b.png"
    ],
    image: "/lovable-uploads/7c77e150-f844-4d85-87e2-9e7cbb1d2f35.png",
    slug: "dxe-cat-tx2-4k"
  }
];
